import { groupBy, sumBy } from 'lodash';
import { Measurement } from './measurement';
import { IDate } from './types';

export class PercentageDateSummary implements IDate {
  public dateString: string;
  private measurements: Measurement[];

  constructor(dateString: string, measurements: Measurement[]) {
    this.dateString = dateString;
    this.measurements = measurements;
  }

  public get date() {
    return new Date(this.dateString);
  }

  public get count() {
    return this.measurements.length;
  }

  /**
   * returns an array of objects where the value is the value (i.e. -1 for red, 0 for yellow)
   * and the percentage is the perentage of occurences it had during this period
   */
  public get values(): { value: string; percentage: number }[] {
    const groupedByValue = groupBy(this.measurements, m => m.value);

    return Object.keys(groupedByValue).map((valueString: string) => {
      return {
        value: valueString,
        percentage: Math.round((groupedByValue[valueString].length / this.count) * 100)
      };
    });
  }
}
